<script lang="ts">
	import type { OperationModel } from '@app/models/api/OperationModel';
	import SliderInvest from '../../../inputs/SliderInvest.svelte';
	import type { InputRangeProps } from '@wiseed/wikit';
	import { capitalize } from '@wiseed/wikit';
	import { postIntention } from '@app/services/api/subscriptions';
	import { snackbar } from '@wiseed/wikit';
	import { t } from 'svelte-i18n';
	import { ButtonBoxPrimary } from '@wiseed/wikit';

	export let operation: OperationModel;
	export let sliderProps: InputRangeProps;

	sliderProps = {
		...sliderProps,
		min: operation.minCoupon,
		max: operation.maxCoupon,
		step: operation.subscriptionLevel,
		value:
			operation.intention && operation.intention > 0 ? operation.intention : operation.minCoupon,
		thumbColor: 'primary',
		thumbWidth: 15,
		trackColor: 'grey',
		trackHeight: 2,
		required: true,
		hideTooltip: true
	};

	let isPostIntentionFetching = false;

	const handlePostIntention = async () => {
		isPostIntentionFetching = true;
		try {
			await postIntention(operation.id.toString(), { amount: sliderProps.value as number });
			snackbar.open({ message: $t('subscription.queue.intentionSaved') });
		} catch (e) {
			snackbar.danger($t('feedback.unavailable'));
			throw e;
		} finally {
			isPostIntentionFetching = false;
		}
	};
</script>

<div class="pb-2 md:pb-3 leading-7 last:pb-0 space-y-4">
	<SliderInvest bind:props={sliderProps} />
	<ButtonBoxPrimary
		props={{
			label: capitalize($t('operation.performance.intention')),
			fetching: isPostIntentionFetching,
			classNames: 'w-full flex justify-center items-center',
			progressColor: 'white'
		}}
		on:click={() => handlePostIntention()}
	/>
</div>
